import { BaseFilter } from '@/hooks/usePaginationFilter';

export interface TBuild {
  _id: string;
  name: string;
  version?: string;
  size?: { key: string; frameSize?: { x: number; y: number } };
  pages: string;
  popups: string;
  cfds?: string;
  previewImage?: string;
  companyId?: string;
  accountId?: string;
  sourceId?: string;
  automations?: string;
  actions?: string;
  globalBlocks?: string | null;
  globalBlockType?: GlobalBlockTypes;
  tag?: BuildTags;
  description?: string;
  buildType: TypeOfBuild;
  pageType?: PageTypes;
  isPublished: boolean;
  languageCode?: string;
  features?: string[];
  idealFor?: string[];
  supportedOS?: string[];
  seeDetailsURL?: string;
  organizationId?: string;
}

export interface ManagedBuildReference {
  _id: string;
  companyId: string;
  buildId: string;
  enableCashManagement: boolean;
  requireEmployeePin: boolean;
  paymentSettings: PaymentSettings;
}

export interface BuildPaginationFilter extends BaseFilter {
  search?: string;
  buildType?: TypeOfBuild;
  organizationId?: string;
  isDeleted?: boolean;
  globalBlockType?: GlobalBlockTypes;
  isPublished?: boolean;
}

export interface PaymentSettings {
  final: boolean;
  cash: boolean;
  vendara: boolean;
}

export type Page = {
  components: {
    [key: string]: {
      globalBlock: string;
    };
  };
};

export enum GlobalBlockTypes {
  GB_PRINT = 'globalBlockPrint',
  GB_CFD = 'globalBlockCFD',
  GB_GC = 'globalBlockGridCard',
  GB_CI = 'globalBlockCI',
}

export enum PageTypes {
  CHECKOUT = 'checkout',
  CUSTOMER = 'customer',
  GIFT_CARD = 'giftCard',
  CARD_ITEM = 'cardItem',
}

export enum TypeOfBuild {
  BUILD = 'build',
  TEMPLATE = 'template',
  OLIVER_TEMPLATE = 'oliverTemplate',
  ORG_TEMPLATE = 'orgTemplate',
  GLOBAL_BLOCK = 'globalBlock',
  OLIVER_THEME = 'oliverTheme',
  OLIVER_GLOBAL_BLOCK = 'oliverGlobalBlock',
  ORG_THEME = 'orgTheme',
  ORG_GLOBAL_BLOCK = 'orgGlobalBlock',
}

export enum BuildTags {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  KIOSK = 'kiosk',
  KITCHEN = 'kitchen',
  OTHER = 'other',
}

export const GlobalBlockImages = {
  [GlobalBlockTypes.GB_PRINT]: '/print-global-block-image.png',
  [GlobalBlockTypes.GB_CFD]: '/cfd-global-block.png',
  [GlobalBlockTypes.GB_GC]: '/grid-global-block.png',
  [GlobalBlockTypes.GB_CI]: '/ci-global-block.png',
};

export const isGlobalBlock: { [key: string]: boolean } = {
  [TypeOfBuild.GLOBAL_BLOCK]: true,
  [TypeOfBuild.ORG_GLOBAL_BLOCK]: true,
  [TypeOfBuild.OLIVER_GLOBAL_BLOCK]: true,
};
